import { render, staticRenderFns } from "./PurchaseOrderResolvePOToRFMsItem.vue?vue&type=template&id=ca0344d2&"
import script from "./PurchaseOrderResolvePOToRFMsItem.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderResolvePOToRFMsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports